import React from "react";
import Logo from '../components/Logo';
import HeroSection from '../components/HeroSection';
import HowTo from '../components/HowTo';
import Footer from "../components/Footer";
import '../styles/Home.css';

const About = () => {
    return (
        <div className="main-container gamified-bg">
            <Logo showAuthButtons />
            <div className="content-wrap fade-in-up">
                <HeroSection />
                <HowTo />
            </div>
            <Footer />
        </div>
    )
};

export default About;
